import img66 from './EquipoMedico/img66.jpg'
import { Footer } from './Footer'
import React, { Component } from 'react'
import { Card, Row, Col, Container } from 'react-bootstrap'
import { Navigation } from './Navigation'

export class Ginecologia extends Component {
    render() {
        return (
            <div>
                <Navigation />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Ginecología</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Usamos justify-content-center para centrar la Card.
                        md={10} lg={8}: Controla que no se estire al 100% del ancho, 
                        manteniendo una proporción ideal para lectura.
                    */}
                    <Row className="justify-content-center">
                        <Col xs={12} md={10} lg={8}>
                            <Card className="shadow border-0 text-center">
                                <Card.Body className="p-3">
                                    <Card.Img 
                                        variant="top" 
                                        src={img66} 
                                        style={{ 
                                            width: '100%', 
                                            height: 'auto', // Auto para que no se deforme el texto informativo
                                            maxHeight: '800px', // Límite para que no sea infinita
                                            objectFit: 'contain' 
                                        }} 
                                    />
                                </Card.Body>
                                <Card.Footer className="bg-white border-0">
                                    <Card.Title style={{ fontSize: '1.8rem', padding: '10px' }}>
                                        Ginecología
                                    </Card.Title>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}